import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1585.277 -4146.566)">
      <path
        d="M58.473,43.316a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1628 4104)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M68.112,46.829a14.939,14.939,0,0,0-9.639-3.513v15l14.76-2.6a14.979,14.979,0,0,0-5.121-8.885"
        transform="translate(-1628 4104)"
        fill={color}
      />
    </g>
  </svg>
);
